import { UpdateSubscriberSchema } from "@stw/yup-validators";

import {
  AudienceContactFieldType,
  AudienceFieldData,
  GetAudienceContactFieldsQuery,
} from "~frontend/__generated__/graphql";

export function createUpdateSubscriberInitialValues(
  subscriberId: string,
  fieldData: AudienceFieldData[],
  audienceContactFields: GetAudienceContactFieldsQuery["getAudienceContactFields"]
): { subscriberId: string; fields: { [p: string]: any } } {
  const contactFields = fieldData.reduce(
    (acc, field) => {
      if (field.type === AudienceContactFieldType.Boolean) {
        acc[field.name] = field.value != null ? field.value : null;
      } else {
        acc[field.name] = field.value || null;
      }
      return acc;
    },
    {} as Record<string, string | boolean | null>
  );

  return UpdateSubscriberSchema(audienceContactFields).parse({
    subscriberId,
    fields: contactFields,
  });
}
